var ko = require('knockout');

ko.components.register('purchase-button', {
  viewModel: require('./purchase-button'),
  template: require('./purchase-button.template')
});

$('[data-purchase-button]').each(function() {
  ko.applyBindings({}, this);
});
